import { isDebugModeSupported } from '../environment'
import { getSafeLocalStorageItem, setSafeLocalStorageItem } from '../utils/SafeLocalStorage'

const DebugModeSavedPrefKey = 'clipsal-iconic-configurator.debugMode'

export function getDebugModeSavedPref(): boolean {
  return isDebugModeAvailable() && getSafeLocalStorageItem(DebugModeSavedPrefKey) === 'true'
}

export function setDebugModeSavedPref(enabled: boolean) {
  setSafeLocalStorageItem(DebugModeSavedPrefKey, `${enabled ? 'true' : 'false'}`)
}

function getQueryParams() {
  return new URLSearchParams(window.location.search)
}

export function isDebugModeAvailable() {
  return isDebugModeSupported() && getQueryParams().has('debug')
}

export function shouldUseLocalProducts() {
  return getQueryParams().has('offlineProducts')
}

export function shouldUseFakeAuth() {
  return getQueryParams().has('fakeAuth')
}